<script>
export default {
  name: "App",
  data() {
    return {
      lang: window.location.hostname.includes(".com") ? "en" : "fr",
      email: "",
      pwd: "",
      connected: false
    };
  },
  computed: {
    message() {
      if (this.connected) {
        if (this.lang === "fr") {
          return `Bienvenue dans votre espace client, vous êtes connecté !`;
        } else {
          return `Welcome into your client area, you are connected !`;
        }
      } else {
        if (this.lang === "fr") {
          return `Saisissez votre adresse mail et votre mot de passe
                  pour vous connecter :`;
        } else {
          return `Enter your email address and your password
                  to connect to your client account :`;
        }
      }
    }
  },
  created() {
    // vérif du cookie courant s'il y en a un
    this.$axios.get("/BD/auth/checkCookie").then(response => {
      if (response.data.messagetype === "success") {
        this.email = response.data.message;
        this.connected = true;
      }
    });
  },
  methods: {
    printResas() {
      if (!this.email) return true;
      this.$Progress.start();
      this.$axios
        .get("/icat/api/printresas?email=" + this.email)
        .then(response => {
          if (response.data.includes("/icatprint")) {
            window.location.assign(response.data);
          } else {
            this.$toasted.error(response.data);
          }
        })
        .finally(() => {
          this.$Progress.finish();
        });
    },

    disconnect() {
      this.$axios.get("/BD/auth/logout").finally(() => {
        // enlever le cookie pjweb
        this.$axios.get("/icat/api/clear-pjweb-cookie").finally(() => {
          window.location.replace(window.location.href);
        });
      });
    },

    connect() {
      if (!this.email) {
        this.$toasted.info("Veuillez saisir votre email");
        return false;
      }
      if (!this.pwd) {
        this.$toasted.info("Veuillez saisir votre mot de passe");
        return false;
      }
      this.$axios
        .post("/BD/auth/login", {
          email: this.email,
          pwd: this.pwd
        })
        .then(response => {
          if (response.data.messagetype === "success") {
            // ajouter le cookie pjweb
            // eslint-disable-next-line no-unused-vars
            this.$axios.get("/icat/api/add-pjweb-cookie").finally(response => {
              window.location.assign(window.location.href);
            });
          } else {
            this.$toasted.info(response.data.message);
          }
        })
        .catch(e => {
          this.$toasted.info("Erreur réseau. Veuillez recommencer ultérieurement");
          window.thinlogger("axios " + e + " response " + JSON.stringify(e.response));
        });
    },

    sendPwd() {
      if (!this.email) {
        this.$toasted.info("Veuillez saisir votre adresse mail");
        return false;
      }

      this.$Progress.start();
      this.$axios
        .get("/icat/api/sendpwd?email=" + this.email)
        .then(response => {
          this.$toasted.info(response.data.message);
        })
        .finally(() => {
          this.$Progress.finish();
        });
    }
  }
};
</script>

<template>
  <div id="app">
    <main class="c-main" role="main">
      <div class="o-wrapper">
        <nav class="c-breadcrumb u-hidden--um" aria-label="Vous êtes ici">
          <ul class="c-breadcrumb__list">
            <li class="c-breadcrumb__item">
              <a href="#">Accueil</a>
            </li>
            <li class="c-breadcrumb__item">Connexion</li>
          </ul>
        </nav>

        <h1 class="c-h1">{{ lang === "fr" ? "Identification client" : "Client connexion" }}</h1>
        <div class="c-form c-form--dark c-form--center">
          <p class="c-form__label message">{{ message }}<br /></p>
          <div class="c-form__container input-email-container">
            <label class="c-form__instruction" for="input-email">{{
              lang === "fr" ? "Identifiant" : "Account name or email"
            }}</label>
            <input id="input-email" v-model="email" name="email" class="c-form__input" @keyup.enter="connect" />
            <img alt="Ok" v-if="connected" id="input-email-ok" src="img/ok.svg" height="24" width="24" />
          </div>
          <div class="c-form__container">
            <label class="c-form__instruction" for="input-password">{{
              lang === "fr" ? "Mot de passe" : "Password"
            }}</label>
            <input
              id="input-password"
              v-model="pwd"
              name="pwd"
              class="c-form__input"
              type="password"
              @keyup.enter="connect"
            />
          </div>
          <div class="c-form__submit">
            <a class="c-form__forgotten-password" @click="sendPwd">
              {{ lang === "fr" ? "Mot de passe oublié ?" : "Forgotten password ?" }}
            </a>
            <button id="disconnect" class="c-btn c-btn--invert" @click="disconnect">
              {{ lang === "fr" ? "Déconnecter" : "Disconnect" }}
            </button>
            <button id="submit" class="c-btn c-btn--invert" @click="connect">
              {{ lang === "fr" ? "Connecter" : "Connect" }}
            </button>
          </div>
        </div>
        <ul v-if="connected" class="user-links c-pagination c-pagination--short" style="margin-bottom:2em;">
          <li class="c-pagination__item">
            <a href="/icat/telechargements.html" class="c-pagination__link">Mes téléchargements</a>
          </li>
          <li class="c-pagination__item">
            <a data-test="pdfReservation" class="c-pagination__link" @click="printResas">Mes réservations</a>
          </li>
        </ul>
      </div>
    </main>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<style>
.message {
  margin-bottom: 1.1em;
  font-size: 1.2em;
  font-weight: 500;
}
#input-email {
  font-size: 1.1em;
  font-weight: 500;
  color: darkblue;
}
.c-form__submit {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .c-form__submit {
    flex-direction: column;
    align-items: center;
  }
  .c-form__submit > button {
    margin-top: 1.1em;
  }
}
.c-form__forgotten-password {
  cursor: pointer;
  font-size: 1.1em;
}
.input-email-container {
  position: relative;
}
#input-email-ok {
  position: absolute;
  top: 2.1em;
  left: 90%;
}
.user-links .c-pagination__link {
  font-size: 1.2em;
  font-weight: 500;
  cursor: pointer;
}
</style>
